import { z } from "zod";

export const I18nDisplayName = z
  .object({
    zh: z.string().optional(),
    en: z.string().optional(),
    ja: z.string().optional(),
  })
  .partial();
export type I18nDisplayName = z.infer<typeof I18nDisplayName>;

export type UseCase<Result> = {
  readonly execute: () => Promise<Result>;
};

export type UseCaseWithParams<Result, Params> = {
  readonly execute: (params: Params) => Promise<Result>;
};
